import { asKeyedRoutes } from '../utils/asKeyedRoutes';

export const checkInRoutes = asKeyedRoutes({});
